module.exports = __webpack_public_path__ + "static/media/WoollenLandA0009.0327f0d1.png";